import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["value", "extension"];
import { Component } from 'react';
import formatPhoneNumber from 'I18n/utils/formatPhoneNumber';
// @ts-expect-error untyped JS module
import formatPhoneNumberWithExtension from 'I18n/utils/formatPhoneNumberWithExtension';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
export default class FormattedPhoneNumber extends Component {
  render() {
    const _this$props = this.props,
      {
        value,
        extension
      } = _this$props,
      passThroughProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx("span", Object.assign({}, passThroughProps, {
      children: extension ? formatPhoneNumberWithExtension(value, extension) :
      // @ts-expect-error formatPhoneNumber accepts 1 arg at runtime
      formatPhoneNumber(value)
    }));
  }
}
FormattedPhoneNumber.displayName = 'FormattedPhoneNumber';
FormattedPhoneNumber.contextType = I18nHMRContext;